/**
 * Listas pequeñas de la clínica que antes venían escritas en la pantalla
 * (V2, 28/9/2026): viven en la base (`backend/services/listas_clinica.py`),
 * las lee todo el personal y solo un administrador las cambia, desde el
 * Catálogo de cirugías. Aquí no hay valores por defecto: sin lista, la
 * pantalla que la usa se degrada y Configuración avisa.
 *
 *   GET /api/listas-clinica/{clave} → { valores, actualizado_at, actualizado_por }
 *   PUT /api/listas-clinica/{clave}   { valores }   (admin)
 */
import { useEffect, useState } from 'react';
import { api } from './api';

export const PRODUCTOS_MAPA_FACIAL = 'mapa_facial_productos';
export const INTERVENCIONES_REGISTRO_QX = 'registro_qx_intervenciones';
// Listas cerradas: el servidor comprueba contra ellas lo que se guarda.
//   · lugares del quirófano [{ nombre, propio }] (propio = la propia clínica)
//   · clínicas del planificador antiguo de quirófano [{ nombre }]
//   · clínicas de procedencia que admiten «otro cirujano» a mano [{ nombre }]
export const LUGARES_QUIROFANO = 'quirofano_lugares';
export const CLINICAS_QUIROFANO = 'quirofano_clinicas';
export const CLINICAS_OTRO_CIRUJANO = 'clinicas_otro_cirujano';

export const urlLista = (clave) => `/api/listas-clinica/${clave}`;

const VIGENCIA_MS = 60 * 1000;
const guardadas = {};

/** Una petición por lista y minuto; un fallo no se guarda. Devuelve la
 *  lista de valores (vacía si no hay o no se puede leer). */
export function cargarLista(clave, { forzar = false } = {}) {
  const ya = guardadas[clave];
  if (!forzar && ya && Date.now() - ya.desde < VIGENCIA_MS) return ya.promesa;
  const promesa = api.get(urlLista(clave))
    .then((r) => (Array.isArray(r?.data?.valores) ? r.data.valores : []))
    .catch(() => {
      delete guardadas[clave];
      return [];
    });
  guardadas[clave] = { promesa, desde: Date.now() };
  return promesa;
}

/** Tras guardar desde el Catálogo: que las pantallas la vuelvan a pedir. */
export function olvidarListas() {
  Object.keys(guardadas).forEach((k) => { delete guardadas[k]; });
}

/** [valores, cargada]: vacía hasta que contesta el servidor. */
export function useListaClinica(clave) {
  const [estado, setEstado] = useState({ valores: [], cargada: false });
  useEffect(() => {
    let vivo = true;
    cargarLista(clave).then((valores) => {
      if (vivo) setEstado({ valores, cargada: true });
    });
    return () => { vivo = false; };
  }, [clave]);
  return [estado.valores, estado.cargada];
}
